import { publish } from 'pub-sub';
import { logTimesync } from 'logger';
import delay from 'lodash-es/delay';
import svc from './svc';
export class TimeSync {
    latency = 0;
    offset = 0;
    requiredResponses;
    resyncTime;
    handle = null;
    serverTimes = [];
    workLatency = [];
    constructor(opts = {}) {
        this.requiredResponses = opts.requiredResponses || 0;
        this.resyncTime = opts.resyncTime || 10;
    }
    sync() {
        try {
            const t = this.offset;
            const d = this.fixTime() - t;
            if (d < 1000 * 60 * this.resyncTime) {
                return;
            }
        }
        catch (e) {
        }
        this.serverTimes = [];
        this.workLatency = [];
        this.getServerTime();
    }
    cancel() {
        if (this.handle) {
            clearInterval(this.handle);
            this.handle = null;
        }
    }
    getNow() {
        return new Date().getTime();
    }
    parseServerResponse(data) {
        const origtime = data.originaltime;
        const delayamt = (this.getNow() - origtime) / 2;
        const offset = data.offset - delayamt;
        this.serverTimes.push(offset);
        this.workLatency.push(delayamt);
        if (this.serverTimes.length >= this.requiredResponses) {
            let average = this.serverTimes.reduce((prev, curr) => prev + curr, 0);
            this.offset = Math.round(average / this.serverTimes.length);
            average = this.workLatency.reduce((prev, curr) => prev + curr, 0);
            this.latency = Math.round(average / this.workLatency.length);
            logTimesync.info(() => `latency: ${this.latency}ms; drift: ${this.offset}ms`);
            publish('timesync:updated', {
                latency: this.latency,
                drift: this.offset
            });
        }
        else {
            delay(this.getServerTime.bind(this), 100);
        }
    }
    getServerTime() {
        svc.server_time({
            clienttime: this.getNow()
        }).then(this.parseServerResponse.bind(this));
    }
    fixTime(timeStamp) {
        const stamp = timeStamp || this.getNow();
        return stamp + this.offset;
    }
    now() {
        return new Date(this.getNow() + this.offset);
    }
    startup() {
        const waitfor = 1000 * 60 * this.resyncTime;
        this.sync();
        this.handle = setInterval(this.sync.bind(this), waitfor);
    }
}
export const timesync = new TimeSync();
export default timesync;
